require('jssocials');
require('jssocials/dist/jssocials.css');
require('jssocials/dist/jssocials-theme-flat.css');

require('@fortawesome/fontawesome-free/css/all.css');

// app.debug = true;

$(document).ready(function(){
  // new app.Konami({
  //   code : function(){
  //     $('img').replaceWith('<img src="https://i.gifer.com/IOKL.gif" alt="" />')
  //   }
  // });

  $(".share-container").jsSocials({
    shares: [
      {share: "email", },
      {share: "twitter", logo: 'fab fa-twitter'},
      {share: "facebook", logo: 'fab fa-facebook'},
      // {share: "googleplus", logo: 'fab fa-google-plus-g'},
      {share: "linkedin", logo: 'fab fa-linkedin'},
      // {share: "pinterest", logo: 'fab fa-pinterest'},
      {share: "whatsapp", logo: 'fab fa-whatsapp'},
    ],
    showLabel : false
  });

  $('.list__filters--2').find('select,input').on('change',function(){
    $(this).closest('form').submit();
  });
  $('.list__filters button[type="reset"]').on('click',function(){
    $(this).closest('form').find('select,input').val('').trigger('change');
  });

  // slider/carousel management
  $('.sliderFW.preset--carousel').each(function(index,item){
    setTimeout(function(){
      var slider = $(item).sliderFW('get');
      slider.$el.find('.sliderFW__arrow').appendTo(slider.$el);

      slider.content.items.on('click',function(e){
        if(!$(this).hasClass('active')){
          var index = $(this).index();
          if($(this).index() < slider.content.items.filter('.active').index())
            slider.goToPrev();
          else
            slider.goToNext();
        }
      });
      slider.onResize();
    },1);
  });

  // encapsulate iframe in 16:9 box
  $('.mod_article iframe:not(.custom)').each(function(){
    $(this).wrapAll('<div class="img-container r_16-9 m-bottom"></div>');
  });

  // create modal from block-img with class hasModal
  $('.block-img.hasModal a').each(function(){
    var link = $(this);
    var modal = new app.ModalFW({
      name : 'imgModal_'+utils.uniqid(),
      url: link.attr('href'),
      selector: '#main',
      $trigger: link,
    });
    link.attr('data-modal',modal.name);
  });

  // scrolling button home management
  $('.goto--home').on('click',function(e){
    e.preventDefault();
    var target = $(this).data('goto').split(',');
    if (target.length == 1) target = target[0];else {
      $.each(target, function (index, item) {
        if ($('#' + item).length) {
          target = item;
          return false;
        }
      });
    }
    if ($('#' + target).length) {
      $('#headerFW--clone').addClass('stick');
      var scrollValue = $('#' + target).offset().top - ($('#headerFW--clone').outerHeight() || 0);
      $('body,html').animate({
        scrollTop: scrollValue
      }, 600).promise().then(function(){
        $('#headerFW--clone').removeClass('stick');
      });
    }
  });

  // personal data link in footer management
  if(!$('#footer li.personalData').closest('ul').length){
    $('.footer__nav nav ul.level_1').append($('#footer li.personalData'));
  }

  // topbar responsive management
  $('body').on('click','.headerFW__nav__toggler',function(){
    if ($(this).hasClass('active'))
      $('.headerFW__nav .topbar').addClass('active');
    else
      $('.headerFW__nav .topbar').removeClass('active');
  });

  // slide pages management
  $('.mod_article.slide').each(function(){
    $(this).children().not('.slide__img').wrapAll('<div class="slide__content"></div>');
    if($(this).hasClass('txt-pack'))
      $(this).find('.slide__content .ce_text').wrapAll('<div class="slide__content__pack"></div>');
    if($(this).hasClass('counter-pack'))
      $(this).find('.slide__content .countUpFW').wrapAll('<div class="slide__content__pack"></div>');
    $(this).addClass('active');
  });
  $('body.slides').addClass('active');

  // news button home management
  $('body').on('click','.toggler--news',function(){
    $('#home--news--grid,.home--news--grid').toggleClass('active');
  });

  // breadcrumb management
  if($('.mod_breadcrumb+.mod_article.first .heroFW.first:first-child').length)
    $('.mod_breadcrumb+.mod_article.first .heroFW.first:first-child').after($('.mod_breadcrumb'));
  if($('.mod_breadcrumb+.mod_article.first .sliderFW.first:first-child').length)
    $('.mod_breadcrumb+.mod_article.first .sliderFW.first:first-child').after($('.mod_breadcrumb'));
  $('.mod_breadcrumb').addClass('active');


  $(window).resize(function(){
    $('.mod_article.h-full').css('min-height', utils.getViewportHeight());
    $('.mod_article.slide .slide__img').css('min-height', utils.getViewportHeight());
  }).trigger('resize');
});


// WEBPACK FOOTER //
// ./src/themes/altrad/altrad.js